/**
 * Utility functions for lazy loading
 * Separated to comply with react-refresh/only-export-components
 */

import React from 'react';

// Higher-order component for lazy loading with suspense
export const withLazyLoading = <P extends object>(
  LazyComponent: React.LazyExoticComponent<React.ComponentType<P>>,
  fallbackComponent?: React.ComponentType
) => {
  const WrappedComponent: React.FC<P> = (props) => {
    const FallbackComponent = fallbackComponent || (() => React.createElement('div', null, 'Loading...'));

    return React.createElement(
      React.Suspense,
      { fallback: React.createElement(FallbackComponent) },
      React.createElement(LazyComponent, props)
    );
  };

  return WrappedComponent;
};